import { render, staticRenderFns } from "./RecoveryConfirm.vue?vue&type=template&id=7d4db239&scoped=true&"
import script from "./RecoveryConfirm.vue?vue&type=script&lang=js&"
export * from "./RecoveryConfirm.vue?vue&type=script&lang=js&"
import style0 from "./RecoveryConfirm.vue?vue&type=style&index=0&id=7d4db239&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d4db239",
  null
  
)

export default component.exports